import React from "react";
import { Button, Typography, Upload, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const { Text } = Typography;

export default function PdfUploadField({
    label,
    file,
    setFile,
    required = true,
    maxSizeMb = 10,
}) {
    const beforeUpload = (nextFile) => {
        const isPdf = nextFile.type === "application/pdf";
        if (!isPdf) {
            message.error(`${label} must be a PDF`);
            return Upload.LIST_IGNORE;
        }

        const isWithinLimit = nextFile.size / 1024 / 1024 <= maxSizeMb;
        if (!isWithinLimit) {
            message.error(`${label} must be smaller than ${maxSizeMb} MB`);
            return Upload.LIST_IGNORE;
        }

        setFile(nextFile);
        return false;
    };

    return (
        <div>
            <div style={{ marginBottom: 8, fontWeight: 600 }}>
                {label} {required ? "*" : ""}
            </div>

            <Upload
                accept=".pdf"
                beforeUpload={beforeUpload}
                onRemove={() => setFile(null)}
                fileList={file ? [file] : []}
                maxCount={1}
            >
                <Button icon={<UploadOutlined />}>Select PDF</Button>
            </Upload>

            <div style={{ marginTop: 8 }}>
                <Text type="secondary">
                    Allowed: PDF only, max {maxSizeMb} MB
                </Text>
            </div>
        </div>
    );
}